import _ from 'lodash';
import {connect} from 'react-redux';
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import classNames from 'classnames';

import {TextField, TextAreaField, NumberField} from 'components/Fields';
import FormField from 'components/FormField';
import Label from 'components/Label';
import {SearchField} from 'components/Fields';
import ErrorBlock from 'components/ErrorBlock';

import {headOption} from 'utils/common';

import {
  MODALS,
  editOneOffChargeReason,
  fetchOneOffChargeReasons
} from 'ducks/oneOffChargeReasons';
import {closeModal, selectModal} from 'ducks/modals';

import './styles.css';

export const buildXeroAccountSelectizeOption = acc => ({
  value: acc.id,
  label: `${acc.code} - ${acc.name}`
});

const formSubmit = (values, dispatch, props) => {
  const {locationRef} = props;
  const {label, description, amount, reasonId, account} = values;
  const submitData = {
    reasonId,
    label,
    description,
    amount,
    locationRef,
    account: account.value
  };

  const extraActions = [
    () => closeModal(MODALS.EDIT_ONE_OFF_CHARGE_REASON),
    () => fetchOneOffChargeReasons({locationRef})
  ];

  dispatch(editOneOffChargeReason(submitData, extraActions));
};

class EditOneOffChargeReasonForm extends React.Component<any> {
  render() {
    const {className, error, xeroAccounts} = this.props;

    return (
      <div className="EditOneOffChargeReasonForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <form className={classNames(className, 'EditOneOffChargeReasonForm')}>
          <FormField>
            <Label>Label</Label>
            <Field name="label" component={TextField} />
          </FormField>
          <FormField>
            <Label>Description</Label>
            <Field name="description" component={TextAreaField} />
          </FormField>
          <FormField>
            <Label>Amount</Label>
            <Field
              className="amount"
              name="amount"
              component={NumberField}
              step="0.01"
            />
          </FormField>
          <FormField>
            <Label>Account</Label>
            <Field
              name="account"
              component={SearchField}
              options={xeroAccounts.map(buildXeroAccountSelectizeOption)}
              disabled={xeroAccounts.length <= 1}
            />
          </FormField>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {data: {reason, xeroAccounts}} = selectModal(
    state,
    MODALS.EDIT_ONE_OFF_CHARGE_REASON
  );
  const account = headOption(
    _.filter(xeroAccounts, acc => acc.id === reason.xeroAccount.id),
    buildXeroAccountSelectizeOption
  );

  return {
    initialValues: {
      reasonId: reason.id,
      label: reason.label,
      description: reason.description,
      amount: reason.amount,
      account
    }
  };
};

export default connect(mapStateToProps, null)(
  reduxForm({
    form: 'editOneOffChargeReason',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(EditOneOffChargeReasonForm)
);
